import * as TK from 'components/comments/CommentForm/translations/constants';
import { Translations } from 'translations/types';

export const commentFormEnUsLocale: Translations = {
  [TK.COMMENT_FORM_PLACEHOLDER]: 'Type your comment...',
  [TK.COMMENT_FORM_REPLY_BOX]: 'Replying to ',
  [TK.COMMENT_FORM_REPLY_BOX_CANCEL_BUTTON_LABEL]: 'Cancel',
};
